import { TrendingUp, Flame } from 'lucide-react';

const topics = [
  { id: 'topic-001', slug: 'intentgraph', label: 'IntentGraph', posts: '4.2K', change: '+18%', hot: true },
  { id: 'topic-002', slug: 'machine-learning', label: 'machine-learning', posts: '12.1K', change: '+7%', hot: false },
  { id: 'topic-003', slug: 'distributed-systems', label: 'distributed-systems', posts: '8.7K', change: '+12%', hot: false },
  { id: 'topic-004', slug: 'trust-safety', label: 'trust-safety', posts: '3.1K', change: '+24%', hot: true },
  { id: 'topic-005', slug: 'creator-economy', label: 'creator-economy', posts: '6.4K', change: '+5%', hot: false },
  { id: 'topic-006', slug: 'ux-design', label: 'ux-design', posts: '9.8K', change: '+3%', hot: false },
  { id: 'topic-007', slug: 'supabase', label: 'supabase', posts: '2.3K', change: '+31%', hot: true },
];

export default function TrendingTopics() {
  return (
    <div className="card-elevated p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <TrendingUp size={14} className="text-secondary" />
          <span className="text-sm font-600 text-foreground">Trending Topics</span>
        </div>
        <span className="text-xs text-muted-foreground">Last 24h</span>
      </div>

      <div className="space-y-2">
        {topics?.map((topic, index) => (
          <div
            key={topic?.id}
            className="flex items-center gap-3 p-2 rounded-lg hover:bg-muted/50 cursor-pointer transition-colors group"
          >
            <span className="text-xs text-muted-foreground/50 font-mono w-4 numeric-tabular flex-shrink-0">
              {index + 1}
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1.5">
                <span className="text-sm font-500 text-foreground group-hover:text-accent transition-colors truncate">
                  #{topic?.slug}
                </span>
                {topic?.hot && (
                  <Flame size={11} className="text-orange-400 flex-shrink-0" />
                )}
              </div>
              <div className="text-xs text-muted-foreground">{topic?.posts} posts</div>
            </div>
            <span className="text-xs font-600 text-emerald-400 flex-shrink-0 numeric-tabular">
              {topic?.change}
            </span>
          </div>
        ))}
      </div>

      <button className="w-full mt-3 text-xs text-accent hover:underline text-center py-1">
        Show all trending topics
      </button>
    </div>
  );
}